import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NetworkLinkedDocumentCategory } from 'src/modules/enaio/netgen/NetworkLinkedDocumentCategory';
import { AdminBaseEditComponent } from 'src/modules/sm-base/components/admin-base-edit/admin-base-edit.component';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';

@Component({
    selector: 'app-edit-network-linked-document-category',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditNetworkLinkedDocumentCategoryComponent extends AdminBaseEditComponent<NetworkLinkedDocumentCategory> {

    definition = ProjectPlanningTools.definitionNetworkLinkedDocumentCategory;

    getForm(): FrontendForm {
        return this.app.tForm('entity.NetworkLinkedDocumentCategory.fields', new FrontendForm([
            new FrontendField('title', '', FrontendFieldType.string, { mandatory: true })
        ]));
    }
}
